export default __webpack_public_path__ + "static/media/no-skills.981c096f.svg";